import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UiErrorParser } from '../ui-error-parser';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable()
export class ComissoesErrorParser extends UiErrorParser {
    constructor() {
        super();
        this.setType('comissoes');
    }

    override verifyContext(error: HttpErrorResponse, req: HttpRequest<unknown>): boolean {
        return req.url.includes(SICOM_PATHS.comissoes.base) && error.status !== 0;
    }

    override beforeTextBuild(error: HttpErrorResponse, req: HttpRequest<unknown>): void {
        const detail = this.extractErrorMessage(error);
        if (detail) {
            const isClientBusinessError = error.status >= 400 && error.status < 500;
            this.setTitle(isClientBusinessError ? 'Atencao' : 'Erro');
            this.setSeverity(isClientBusinessError ? 'warn' : 'error');
            this.setMessageStart(detail);
            this.setMethod('');
            this.setTarget('');
            return;
        }

        this.setMessageStart('Nao foi possivel');
        this.setTarget(this.resolveTarget(req.url));
    }

    override errorComplement(_error: HttpErrorResponse, _req: HttpRequest<unknown>): string {
        return '';
    }

    private resolveTarget(url: string): string {
        if (url.includes(SICOM_PATHS.comissoes.configuracoes)) {
            return 'as configuracoes de comissoes';
        }
        if (url.includes(SICOM_PATHS.comissoes.atas)) {
            return 'as atas de comissoes';
        }
        if (url.includes(SICOM_PATHS.comissoes.reunioes)) {
            return 'as reunioes de comissoes';
        }
        return 'o modulo de comissoes';
    }
}
